// Libs
import ApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
// Types
import { ChartSetThree } from "../Libs/Types/ChartTypes";
// Utils
import {
  CHART_AXIS_FALLBACK,
  chartColors,
  chartHeight,
} from "../Libs/Utils/utils";
// UI-Components
import ChartFallBack from "../UI-Components/ChartFallback";

export default function CandleStickChart({
  chartData,
  dataKey,
}: {
  chartData: ChartSetThree["CandleStickChart"];
  dataKey: string;
}) {
  const option: ApexOptions = {
    chart: {
      fontFamily: "Poppins",
      toolbar: {
        show: true,
      },
    },
    dataLabels: {
      style: {
        fontSize: "8px",
      },
    },
    legend: {
      show: false,
    },
    plotOptions: {
      candlestick: {
        colors: {
          upward: chartColors,
          downward: chartColors,
        },
      },
    },
    fill: {
      colors: chartColors,
    },
    colors: chartColors,
    xaxis: {
      labels: {
        style: {
          fontSize: "8px",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "8px",
        },
      },
    },
    title: {
      style: { fontSize: "14px", fontWeight: "900" },
      text:
        chartData !== undefined
          ? chartData["title"]
          : CHART_AXIS_FALLBACK["title"],
      align: "left",
    },
  };

  const series: any =
    chartData !== undefined && Array.isArray(chartData["data"]) === true
      ? chartData["data"]
      : undefined;

  return (
    <div className="my-2 chartWrp border-1 rounded-lg w-full p-2">
      {series !== undefined ? (
        <ApexChart
          type="candlestick"
          options={option}
          series={series}
          height={chartHeight}
          width={"100%"}
          key={dataKey}
        />
      ) : (
        <ChartFallBack />
      )}
    </div>
  );
}
